import { render, staticRenderFns } from "./Disposition.vue?vue&type=template&id=0ba4ae4a&scoped=true"
import script from "./Disposition.vue?vue&type=script&lang=js"
export * from "./Disposition.vue?vue&type=script&lang=js"
import style0 from "./Disposition.vue?vue&type=style&index=0&id=0ba4ae4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ba4ae4a",
  null
  
)

export default component.exports